export default {
  methods: {
    close(payload) {
      this.$emit('close', payload);
    },
  },
};
